import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import burgerBuilder from './store/reducer/BurgerBuilder';
import order from './store/reducer/order';
import auth from './store/reducer/auth'
import registerServiceWorker from './registerServiceWorker';
import { Provider} from 'react-redux'
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {BrowserRouter} from 'react-router-dom';
import thunk from 'redux-thunk';

const rootReducer = combineReducers({
  bB: burgerBuilder,
  order: order,
  auth: auth
})

const composeEnhancers = (process.env.NODE_ENV === 'development'?
                      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: null) || compose;
const store = createStore(rootReducer, 
              composeEnhancers(
                    applyMiddleware(thunk)
                    ));


ReactDOM.render(
  <BrowserRouter>
  <Provider store={store}>
  <App />
  </Provider>
  </BrowserRouter>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js